import * as actionTypes from "./actionTypes";
import {ReduxState, ReduxAction} from '../type.d';

const initialState: ReduxState = {
  warningModal: false,
  feedbackModal: false,
  sayThanksModal: false,
  successModal: false,
  deleteModal: false,
  dissconnectModal: false,
  addAccountModal: false,
  test: {
    pending: false,
    data: null,
    err: null,
  },
  loginState: {
    pending: false,
    data: null,
    err: null,
  },
  sessionState: {
    pending: false,
    data: null,
    err: null,
  },
  activityState: {
    pending: false,
    data: null,
    err: null,
  },
  deleteUserData: {
    pending: false,
    data: null,
    err: null
  },
  deleteActivity: {
    pending: false,
    data: null,
    err: null
  }
}

const reducer = (
  state: ReduxState = initialState,
  action: ReduxAction
): ReduxState => {
  switch (action.type) {
    case actionTypes.CHANGE_WARNING_MODAL_STATE:
      return ({
        ...state,
        warningModal: !state.warningModal,
      });
    case actionTypes.CHANGE_SUCCESS_MODAL_STATE:
      return ({
        ...state,
        successModal: !state.successModal,
      });
    case actionTypes.CHANGE_DELETE_MODAL_STATE:
      return ({
        ...state,
        deleteModal: !state.deleteModal,
      });
    case actionTypes.CHANGE_DISSCONNECT_MODAL_STATE:
      return ({
        ...state,
        dissconnectModal: !state.dissconnectModal,
      });
    case actionTypes.CHANGE_ADD_ACCOUNT_MODAL_STATE:
      return ({
        ...state,
        addAccountModal: !state.addAccountModal,
      });
    case actionTypes.TEST_STARTED:
      return ({
        ...state,
        test: {
          pending: true,
          data: null,
          err: null,
        }
      });
    case actionTypes.TEST_SUCCESS:
      return ({
        ...state,
        test: {
          pending: false,
          data: action.payload,
          err: null,
        }
      });
    case actionTypes.TEST_FAILED:
      return ({
        ...state,
        test: {
          pending: false,
          data: null,
          err: action.payload,
        }
      });
    case actionTypes.LOGIN_GOOGLE_FETCH:
      return ({
        ...state,
        loginState: {
          pending: true,
          data: null,
          err: null,
        }
      });
    case actionTypes.LOGIN_GOOGLE_SUCCESS:
      return ({
        ...state,
        loginState: {
          pending: false,
          data: action.payload,
          err: null,
        }
      });
    case actionTypes.LOGIN_GOOGLE_FAILED:
      return ({
        ...state,
        loginState: {
          pending: false,
          data: null,
          err: action.payload,
        }
      });
    case actionTypes.GET_USER_DATA_FETCHED:
      return ({
        ...state,
        sessionState: {
          ...state.sessionState,
          pending: true
        }
      });
    case actionTypes.GET_USER_DATA_SUCCESS:
      return ({
        ...state,
        sessionState: {
          ...state.sessionState,
          data: action.payload,
          pending: false,
        }
      });
    case actionTypes.GET_USER_DATA_FAILED:
      return ({
        ...state,
        sessionState: {
          ...state.sessionState,
          err: action.payload,
          pending: false,
        }
      })
      case actionTypes.GET_ACTIVITY_DATA_FETCHED:
      return ({
        ...state,
        activityState: {
          ...state.activityState,
          pending: true
        }
      });
    case actionTypes.GET_ACTIVITY_DATA_SUCCESS:
      return ({
        ...state,
        activityState: {
          ...state.activityState,
          data: action.payload,
          pending: false,
        }
      });
    case actionTypes.GET_ACTIVITY_DATA_FAILED:
      return ({
        ...state,
        activityState: {
          ...state.activityState,
          err: action.payload,
          pending: false,
        }
      })
      case actionTypes.DELETE_USER_FETCHED:
      return ({
        ...state,
        deleteUserData: {
          ...state.deleteUserData,
          pending: true,
        }
      });
    case actionTypes.DELETE_USER_SUCCESS:
      return ({
        warningModal: false,
        feedbackModal: false,
        sayThanksModal: false,
        successModal: false,
        deleteModal: false,
        dissconnectModal: false,
        addAccountModal: false,
        test: {
          pending: false,
          data: null,
          err: null,
        },
        loginState: {
          pending: false,
          data: null,
          err: null,
        },
        sessionState: {
          pending: false,
          data: null,
          err: null,
        },
        activityState: {
          pending: false,
          data: null,
          err: null,
        },
        deleteUserData: {
          pending: false,
          data: null,
          err: null
        },
        deleteActivity: {
          pending: false,
          data: null,
          err: null
        },
      });
    case actionTypes.DELETE_USER_FAILED:
      return ({
        ...state,
        deleteUserData: {
          ...state.deleteUserData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.SIGN_OUT:
      return ({
        warningModal: false,
        feedbackModal: false,
        successModal: false,
        sayThanksModal: false,
        deleteModal: false,
        dissconnectModal: false,
        addAccountModal: false,
        test: {
          pending: false,
          data: null,
          err: null,
        },
        loginState: {
          pending: false,
          data: null,
          err: null,
        },
        sessionState: {
          pending: false,
          data: null,
          err: null,
        },
        activityState: {
          pending: false,
          data: null,
          err: null,
        },
        deleteUserData: {
          pending: false,
          data: null,
          err: null
        },
        deleteActivity: {
          pending: false,
          data: null,
          err: null
        },
      });
    case actionTypes.DELETE_ACTIVITY_FETCHED:
      return({
        ...state,
        deleteActivity: {
          ...state.deleteActivity,
          pending: true,
        },
      })
    case actionTypes.DELETE_ACTIVITY_SUCCESS:
      return({
        ...state,
        deleteActivity: {
          ...state.deleteActivity,
          pending: false,
          data: action.payload,
        },
      })
    case actionTypes.DELETE_ACTIVITY_FAILED:
      return({
        ...state,
        deleteActivity: {
          ...state.deleteActivity,
          pending: false,
          err: action.payload,
        },
      })
    case actionTypes.CHANGE_FEEDBACK_MODAL_STATE:
      return({
        ...state,
        feedbackModal: !state.feedbackModal,
      })
    case actionTypes.CHANGE_SAY_THANKS_MODAL_STATE:
      return({
        ...state,
        sayThanksModal: !state.sayThanksModal,
      })
    default:
      return {...state};
  }
}

export default reducer;